import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 50px 0;
`;

const Block = ({ children, className }) => {
  return <Wrapper className={className}>{children}</Wrapper>;
};

Block.propTypes = {
  children: PropTypes.element,
  className: PropTypes.string
};

export default Block;
